import { cva, type VariantProps } from "class-variance-authority";
import React from "react";
import { cn } from "@/core/utils/utils";

const typographyVariants = cva("", {
  variants: {
    variant: {
      initials: "text-3xl font-normal",
      titleW2: "text-3xl font-bold",
      titleW3: "text-2xl font-bold",
      subtitleW0: "text-3xl font-normal",
      subtitleW1: "text-xl font-semibold",
      subtitleW2: "text-lg font-semibold",
      subtitleW3: "text-md font-semibold",
      bodyW1: "text-lg font-normal",
      bodyW2: "text-md font-normal",
      bodyW3: "text-sm font-normal",
      captionW1: "text-sm font-normal",
      captionW1SemiBold: "text-sm font-semibold",
      headlineW3: "text-3xl font-bold font-manrope",
      badge: "text-md font-poppins",
      statNumber: "text-4xl font-bold",
      statNumberW2: "text-5xl font-bold",
      info: "font-inter font-medium",
    },
    textColor: {
      primary: "text-primary-text",
      secondary: "text-secondary-text",
      tertiary: "text-tertiary-text",
      quaternary: "text-quaternary-text",
      interactive: "text-interactive-text",
      negative: "text-negative-text",
      tabSelected: "text-tab-selected-text",
      primaryInverse: "text-primary-inverse-text",
    },
  },
  defaultVariants: {
    variant: "bodyW2",
    textColor: "primary",
  },
});

export interface TypographyProps
  extends React.HTMLAttributes<HTMLParagraphElement>,
    VariantProps<typeof typographyVariants> {
  className?: string;
}

const Typography = ({
  children,
  variant,
  textColor,
  className,
  ...props
}: TypographyProps) => (
  <p
    className={cn(typographyVariants({ variant, textColor, className }))}
    {...props}
  >
    {children}
  </p>
);

export { Typography, typographyVariants };
